import i18n from 'i18next';
import permissionsInfo from '../../constants/permissionsInfo';

const navigation = [
  {
    label: i18n.t('navigation:dashboard'),
    route: '/',
    permissions: permissionsInfo.dashboard.view
  },
  {
    label: i18n.t('navigation:scheduling'),
    isExternal: true,
    externalUrl: 'https://seneca-dashboard.icypond-f961a912.centralus.azurecontainerapps.io/',
    permissions: null
  },
  {
    label: i18n.t('navigation:callSheet'),
    route: '/call-sheets',
    permissions: permissionsInfo.calls.view
  },
  {
    label: i18n.t('navigation:processes'),
    route: '/processes',
    permissions: permissionsInfo.processes.view
  },
  {
    label: i18n.t('navigation:taskList'),
    route: '/tasks',
    permissions: [
      ...permissionsInfo.tasks.view,
      ...permissionsInfo.tasks.group.view,
      ...permissionsInfo.tasks.personal.view
    ]
  },
  {
    label: i18n.t('navigation:operatories'),
    route: '/operatories',
    permissions: permissionsInfo.operatories.overview
  },
  {
    label: i18n.t('navigation:patients'),
    route: '/patients',
    permissions: permissionsInfo.patients.list.view
  },
  {
    label: i18n.t('navigation:surveys'),
    route: '/surveys',
    permissions: permissionsInfo.surveys.list.view
  },
  {
    label: i18n.t('navigation:configuration'),
    isButton: true,
    permissions: [
      ...permissionsInfo.tenants_config.list.users,
      ...permissionsInfo.operatories.view,
      ...permissionsInfo.treatments.view,
      ...permissionsInfo.doctors.view
    ],
    submenu: [
      {
        label: i18n.t('navigation:users'),
        route: '/configuration/users',
        exact: false,
        permissions: permissionsInfo.tenants_config.list.users
      },
      {
        label: i18n.t('navigation:operatories'),
        route: '/configuration/operatories',
        permissions: permissionsInfo.operatories.view
      },
      {
        label: i18n.t('navigation:treatments'),
        route: '/configuration/treatments',
        permissions: permissionsInfo.treatments.view
      },
      {
        label: i18n.t('navigation:referringDoctors'),
        route: '/configuration/referring-doctors',
        permissions: permissionsInfo.doctors.view
      }
    ]
  },
  {
    label: i18n.t('navigation:processSettings'),
    isButton: true,
    permissions: [
      ...permissionsInfo.settings.process_progress_alert_range.manage,
      ...permissionsInfo.settings.task_progress_alert_range.manage,
      ...permissionsInfo.tasks.time.target
    ],
    submenu: [
      {
        label: i18n.t('navigation:targetTaskTimes'),
        route: '/configuration/process-settings/target-task-times',
        permissions: permissionsInfo.tasks.time.target
      },
      {
        label: i18n.t('navigation:alertAlarm'),
        route: '/configuration/process-settings/alert',
        permissions: [
          ...permissionsInfo.settings.process_progress_alert_range.manage,
          ...permissionsInfo.settings.task_progress_alert_range.manage
        ]
      }
    ]
  },
  {
    label: i18n.t('navigation:systemConfiguration'),
    isButton: true,
    visibleWithoutTenantId: true,
    permissions: [
      ...permissionsInfo.users.view,
      ...permissionsInfo.groups.view,
      ...permissionsInfo.tenants.view
    ],
    submenu: [
      {
        label: i18n.t('navigation:users'),
        route: '/system-configuration/users',
        permissions: permissionsInfo.users.view,
        visibleWithoutTenantId: true,
        exact: false
      },
      {
        label: i18n.t('navigation:groups'),
        route: '/system-configuration/groups',
        permissions: permissionsInfo.groups.view,
        visibleWithoutTenantId: true,
        exact: false
      },
      {
        label: i18n.t('navigation:tenants'),
        route: '/system-configuration/tenants',
        permissions: permissionsInfo.tenants.view,
        visibleWithoutTenantId: true,
        exact: false
      }
    ]
  }
];

export default navigation;
